import { SYNC_LIMIT_50 } from '@/utilities/constants';

import { BorerShiftDocument } from '../BorerShift/queryBuilder';
import { InspectionDocument } from '../Inspections/queryBuilder';
import { LocationDocument } from '../Locations/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SignatureDocument } from '../Signature/rxdbSignatureDefinition';
import {
  InspectionResultDocument,
  inspectionResultPullQueryBuilder,
  inspectionResultPushModifier,
  inspectionResultPushQueryBuilder,
} from './queryBuilder';

export function inspectionResultsFamilyMember(
  configBuilder: ConfigBuilder,
  borerShift: FamilyMember<BorerShiftDocument>,
  inspections: FamilyMember<InspectionDocument>,
  locations: FamilyMember<LocationDocument>,
  signatures: FamilyMember<SignatureDocument>,
): FamilyMember<InspectionResultDocument> {
  const syncConfig = configBuilder<InspectionResultDocument>(
    RxdbCollectionNameV2.INSPECTION_RESULTS,
  );
  doNotAutoSync(syncConfig);
  syncConfig.retryTime = 7500;

  const pullConfig = pull(syncConfig, inspectionResultPullQueryBuilder);
  pullConfig.batchSize = SYNC_LIMIT_50;

  const pushConfig = push(syncConfig, inspectionResultPushQueryBuilder);
  pushConfig.modifier = inspectionResultPushModifier;

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.INSPECTION_RESULTS, replicationState, [
    borerShift,
    inspections,
    locations,
    signatures,
  ]);
}
